module.exports = __webpack_public_path__ + "img/collect.fca10db4.png";